import * as React from 'react';
import * as classNames from "classnames";

interface ISimplePaginationProps {
    className?: string;
    maxPagesDisplayed?: number;
    currentPage: number;
    totalRowCount: number;
    numberRowsPerPage: number;
    setPage: (page: number) => void;
}

const defaultMaxPagesDisplayed = 5;

class SimplePagination extends React.Component<ISimplePaginationProps, any> {

    constructor(props, context) {
        super(props, context);

        this.calcNumberOfPages = this.calcNumberOfPages.bind(this);
    }

    calcNumberOfPages(){
        const { numberRowsPerPage, totalRowCount } = this.props;

        return Math.max(Math.ceil(totalRowCount / numberRowsPerPage), 1);
    }

    componentDidMount(){
        // reset to zero if we are on a page that no longer exists
        if(this.props.currentPage >= this.calcNumberOfPages()){
            this.props.setPage(0);
        }
    }

    componentDidUpdate(prevProps: ISimplePaginationProps){
        if(this.props.totalRowCount !== prevProps.totalRowCount){
            this.props.setPage(0);
        }
    }

    render() {
        const { className, currentPage, numberRowsPerPage, totalRowCount, setPage } = this.props;

        const numberOfPages = this.calcNumberOfPages();//Math.max(Math.ceil(totalRowCount / numberRowsPerPage), 1);
        const maxPagesDisplayed = this.props.maxPagesDisplayed ? this.props.maxPagesDisplayed : defaultMaxPagesDisplayed;
        
        const half =  Math.ceil(maxPagesDisplayed / 2);
        const showUpTo = Math.max(maxPagesDisplayed - currentPage, half);
        const pagesFromEnd = numberOfPages - currentPage;
        const showFrom = pagesFromEnd < maxPagesDisplayed ? (maxPagesDisplayed - pagesFromEnd) + 1 : half

        const showFromIndex = currentPage - showFrom;
        const showUpToIndex = currentPage + showUpTo;

        const pages = Array.from({ length: numberOfPages }, p => 0);

        return <nav className={classNames(className)}>
            <ul className="pagination mb-0">
                <li className={classNames("page-item", { "disabled": currentPage == 0 })}>
                    <button className="page-link" onClick={() => setPage(currentPage - 1)}><i className="fa fa-chevron-left" /></button>
                </li>
                {
                    pages.map((p, i) =>
                    i > showFromIndex && i <= showUpToIndex
                        ? <li className={classNames("page-item", { "active": currentPage == i })}
                            key={`page-${i}`}
                        >
                            <button className="page-link" onClick={() => setPage(i)}>
                                {i === showUpToIndex && i !== (numberOfPages - 1) ? '...' : i + 1}
                            </button>
                        </li>
                        : null)

                    /*Array.from({ length: numberOfPages }, (p, i) =>
                        i > showFromIndex && i <= showUpToIndex
                            ? <li className={classNames("page-item", { "active": currentPage == i })}
                                key={`page-${i}`}
                            >
                                <button className="page-link" onClick={() => setPage(i)}>
                                    {i === showUpToIndex && i !== (numberOfPages - 1) ? '...' : i + 1}
                                </button>
                            </li>
                            : null)*/
                }
                <li className={classNames("page-item", { "disabled": currentPage + 1 >= numberOfPages })}>
                    <button className="page-link" onClick={() => setPage(currentPage + 1)}><i className="fa fa-chevron-right" /></button>
                </li>
            </ul>
        </nav>
    }
}

export default SimplePagination;
